define((require) => {
    "use strict";

    const {defaults}          = require("underscore");
    const BreakpointGroup     = require("shared/ui/breakpoint/BreakpointGroup");
    const ChunkingCollection  = require("data/ChunkingCollection");
    const ExperienceModel     = require("shared/ui/experience/ExperienceModel");
    const LocalizationGroup   = require("shared/services/localization/LocalizationGroup");
    const RestApi             = require("shared/services/RestApi");
    const SyncManager         = require("shared/services/sync/SyncManager");
    const LoggedInUserState   = require("shared/ui/user/LoggedInUserState");
    const Configuration       = require("shared/services/Configuration");

    // Defined supported (polymorphic) types/models.
    const contentTypes = new Map();

    contentTypes.set(LocalizationGroup.type, LocalizationGroup);
    contentTypes.set(BreakpointGroup.type, BreakpointGroup);
    contentTypes.set(ExperienceModel.type, ExperienceModel);

    const ContentCollection = ChunkingCollection.extend({

        model: contentTypes,

        url(options) {
            const project = options && options.project;
            const allProjectsContents = options && options.allProjectsContents;
            const isUserPermissionsEnabled = LoggedInUserState.get("companySettings").get("userPermissionsEnabled");

            if (project) {
                // projects/{ID}/contents
                return RestApi.pathToCollectionOnResource(RestApi.Collections.PROJECTS, project.get("id"), RestApi.Collections.CONTENTS);
            } else if (allProjectsContents) {
                // projects/contents
                // Dead code path - might want to delete
                return RestApi.pathToCollection(RestApi.Collections.PROJECTS_ALL_CONTENTS);
            }

            return isUserPermissionsEnabled ? `${Configuration.msExperiencesUrl}/api/contents/` :
                RestApi.pathToCollection(RestApi.Collections.CONTENTS, true);
        }

    }, {

        /**
         * Counts the entire content collection.
         *
         * @param  {Object} options Optional options.
         * @cfg {ProjectModel} project         The <tt>ProjectModel</tt> instance, to count content for a specific project, defaults to <tt>null</tt>.
         *
         * @return {Promise}        A <tt>Promise</tt> that resolves with the count/number.
         */
        count(options) {
            options = defaults(options || {}, {
                project: null
            });

            const {project} = options;
            const target = SyncManager.target("ContentCollection.count");
            let url;
            const isUserPermissionsEnabled = LoggedInUserState.get("companySettings").get("userPermissionsEnabled");

            if (project) {
                url = RestApi.pathToCollectionOnResource(RestApi.Collections.PROJECTS, project.get("id"), RestApi.Collections.CONTENTS_COUNT);
            } else {
                url = isUserPermissionsEnabled ? `${Configuration.msExperiencesUrl}/api/contents/counts/` :
                    RestApi.pathToCollection(RestApi.Collections.CONTENTS_COUNT);
            }
            return SyncManager.get(url, target);
        }

    });

    return ContentCollection;
});



// WEBPACK FOOTER //
// ./src/editor/data/ContentCollection.js